import { z } from "zod";

import { ShopifyTemplateType } from "./shopify";

export const RedirectQueryParamDtoSchema = z.object({
  key: z.string(),
  value: z.string(),
});

export type RedirectQueryParamDto = z.infer<typeof RedirectQueryParamDtoSchema>;

export const RedirectFilterList = [
  "matchesExactly",
  "contains",
  "endsWith",
  "matchesRegex",
  "none",
] as const;
export type RedirectFilter = (typeof RedirectFilterList)[number];

export const UrlRedirectTypeList = [
  "fullReplacement",
  "partialReplacement",
] as const;
export type UrlRedirectType = (typeof UrlRedirectTypeList)[number];

export const RedirectDtoSchema = z.object({
  id: z.string().uuid(),
  group: z.number(),
  variationId: z.string().uuid(),
  originUrl: z.string(),
  destinationUrl: z.string().nullish(),
  queryParams: RedirectQueryParamDtoSchema.array().default([]),
  skip: z.boolean(),
  isThemeTest: z.boolean(),
  isTemplateTest: z.boolean(),
  templateType: z.enum(ShopifyTemplateType).nullish(),
  templateSuffixes: z.string().array().nullish().default([]),
  redirectOnce: z.boolean().default(true),
  filter: z.enum(RedirectFilterList).default("matchesExactly"),
  find: z.string().nullish(),
  redirectType: z.enum(UrlRedirectTypeList).default("fullReplacement"),
});

export type RedirectDto = z.infer<typeof RedirectDtoSchema>;
